import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const CompanyInformationTab = ({ formData, handleChange, handleSelectChange, errors, isEditing }) => {
  const industryOptions = [
    { value: 'real-estate', label: 'Real Estate' },
    { value: 'financial-services', label: 'Financial Services' },
    { value: 'insurance', label: 'Insurance' },
    { value: 'consulting', label: 'Consulting' },
    { value: 'technology', label: 'Technology' },
    { value: 'healthcare', label: 'Healthcare' },
    { value: 'retail', label: 'Retail' },
    { value: 'other', label: 'Other' },
  ];

  const businessTypeOptions = [
    { value: 'llc', label: 'Limited Liability Company (LLC)' },
    { value: 'corporation', label: 'Corporation' },
    { value: 'partnership', label: 'Partnership' },
    { value: 'sole-proprietorship', label: 'Sole Proprietorship' },
    { value: 'non-profit', label: 'Non-Profit Organization' },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Business Name"
          type="text"
          name="businessName"
          value={formData?.businessName}
          onChange={handleChange}
          placeholder="Enter your business name"
          error={errors?.businessName}
          disabled={!isEditing}
          required
        />
        
        <Input
          label="Tax ID / EIN"
          type="text"
          name="taxId"
          value={formData?.taxId}
          onChange={handleChange}
          placeholder="XX-XXXXXXX"
          error={errors?.taxId}
          disabled={!isEditing}
          required
          description="Federal Employer Identification Number"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Industry Type"
          options={industryOptions}
          value={formData?.industryType}
          onChange={(value) => handleSelectChange('industryType', value)}
          placeholder="Select your industry"
          error={errors?.industryType}
          disabled={!isEditing}
          required
        />
        
        <Select
          label="Business Type"
          options={businessTypeOptions}
          value={formData?.businessType}
          onChange={(value) => handleSelectChange('businessType', value)}
          placeholder="Select business structure"
          error={errors?.businessType}
          disabled={!isEditing}
          required
        />
      </div>
      <div className="border-t border-border pt-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Business Address</h3>
        <div className="space-y-6">
          <Input
            label="Street Address"
            type="text"
            name="streetAddress"
            value={formData?.streetAddress}
            onChange={handleChange}
            placeholder="123 Business Street"
            error={errors?.streetAddress}
            disabled={!isEditing}
            required
          />
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Input
              label="City"
              type="text"
              name="city"
              value={formData?.city}
              onChange={handleChange}
              placeholder="Honolulu"
              error={errors?.city}
              disabled={!isEditing}
              required
            />
            
            <Input
              label="State"
              type="text"
              name="state"
              value={formData?.state}
              onChange={handleChange}
              placeholder="HI"
              error={errors?.state}
              disabled={!isEditing}
              required
            />
            
            <Input
              label="ZIP Code"
              type="text"
              name="zipCode"
              value={formData?.zipCode}
              onChange={handleChange}
              placeholder="96813"
              error={errors?.zipCode}
              disabled={!isEditing}
              required
            />
          </div>

          <Input
            label="Website"
            type="url"
            name="website"
            value={formData?.website}
            onChange={handleChange}
            placeholder="https://www.example.com"
            error={errors?.website}
            disabled={!isEditing}
            description="Your company website URL"
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyInformationTab;